import Loader from "../loader/loader";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useRedeemSwitchCodeMutation } from "../../services/api/auth.api";
import { readIsFirst, CDS_POST_ONBOARDING_PATH } from "../../utils/postLoginRedirect";

function SsoRedirectHandler() {
  const navigate = useNavigate();
  const [redeemSwitchCode] = useRedeemSwitchCodeMutation();
  const processedRef = useRef(false);

  useEffect(() => {
    // Prevent double-processing in React StrictMode
    if (processedRef.current) return;

    // Capture the hash first, then immediately wipe it from the URL/history
    // so the code is never visible in browser history or to third-party scripts.
    const hash = window.location.hash;
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!hash) return;

    processedRef.current = true;

    const params = new URLSearchParams(hash.slice(1));
    const code = params.get("code");
    const locale = params.get("lang") || params.get("locale");

    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    // Check if locale needs to change
    const localeChanged = locale && localStorage.getItem("i18nextLng") !== locale;

    if (localeChanged) {
      localStorage.setItem("i18nextLng", locale);
    }

    redeemSwitchCode({ code })
      .unwrap()
      .then((data) => {
        const dest = readIsFirst(data) ? CDS_POST_ONBOARDING_PATH : "/";
        if (localeChanged) {
          window.location.href = dest;
        } else {
          navigate(dest, { replace: true });
        }
      })
      .catch((error) => {
        navigate("/login", { replace: true });
      });
  }, [navigate, redeemSwitchCode]);

  return <Loader />;
}

export default SsoRedirectHandler;
